import { ChipProps } from "@mantine/core";

import { Icon } from "#shared/icons/Icon";
import { EllipsisTooltip } from "#shared/view/components/EditableTable/EllipsisTooltip";
import { Chip } from "#shared/view/designSystem/Chip";

import classes from "./chipTruncate.module.css";

export const SurfaceTreatmentChip = ({
  surfaceTreatment,
  ...props
}: { surfaceTreatment: string } & Partial<ChipProps>) => {
  return (
    <Chip
      size="xs"
      icon={<Icon name="intersect" size={14} />}
      checked
      color="pink.5"
      classNames={{ label: classes.label }}
      {...props}
    >
      <EllipsisTooltip content={surfaceTreatment} />
    </Chip>
  );
};
